// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1__ee9438d914ac31ceded9","cls2":"Banner-cls2___36801dea53f1d27b216 Banner-cls1__ee9438d914ac31ceded9"};